import { environment } from "src/environments/environment.prod";
//LIVE CB_BS server
//const apiUrlBase = environment.production ? 'https://cbsubmissions.centralbankbahamas.com:9000/DormantAccounts' : 'https://cbsubmissions.centralbankbahamas.com:9000/DormantAccounts' ;


//TEST CB_BS server
//const apiUrlBase = environment.production ? 'https://cbsubmissions.centralbankbahamas.com:9000/DormantAccountsTEST' : 'https://cbsubmissions.centralbankbahamas.com:9000/DormantAccountsTEST' ;

//const apiUrlBase = environment.production ? 'http://10.64.46.86:9001/DormantAccounts' : 'http://10.64.46.86:9001/DormantAccounts'; // For Server
//const apiUrlBase = environment.production ? 'http://96.89.127.59:8001/' : 'http://96.89.127.59:8001/'; // For pdx3

const apiUrlBase = environment.production ? 'https://submissions.centralbankbahamas.com/DormantAccounts_TEST' : 'https://submissions.centralbankbahamas.com/DormantAccounts_TEST' ; //TEST Server(Client)

//const apiUrlBase = environment.production ? 'https://submissions.centralbankbahamas.com/DormantAccountsLive' : 'https://submissions.centralbankbahamas.com/DormantAccountsLive' ; //Live Server(Client)


//https://submissions.centralbankbahamas.com/DormantAccounts_TEST
//https://submissions.centralbankbahamas.com/DormantAccountsLive



 //const apiUrlBase = environment.production ? 'http://localhost:53951'  : 'http://localhost:53951' ;
 //44342
//  const apiUrlBase = environment.production ? 'http://localhost:44342'  : 'http://localhost:44342' ;
//  const apiUrlBase = environment.production ? 'https://www.wildsoft.in/abandonedpropertyBackend/'  : 'https://www.wildsoft.in/abandonedpropertyBackend/';

//const apiUrlBase = environment.production ? 'http://192.168.100.10:9020/'  : 'http://192.168.100.10:9020/' ; //Met Server
// const apiUrlBase = environment.production ? 'http://192.168.100.10:9002/'  : 'http://192.168.100.10:9002/' ; //Met Server
//const apiUrlBase = environment.production ? 'http://localhost:61771'  : 'http://localhost:61771' ;
//const apiUrlBase = environment.production ? 'http://pdx3.mimics.us:8001/' : 'http://pdx3.mimics.us:8001/'; // For pdx3 



const CONFIG={
    environment:'full',
    loginApiUrlBase: `${apiUrlBase}/api/login`,
    logoutApiUrlBase:`${apiUrlBase}/api/logout`,
    getbankIdDropdownApiUrlBase:`${apiUrlBase}/api/getbankId`,
    postnoaccountsApiUrlBase:`${apiUrlBase}/api/postnoaccounts`,
    getdataentryDropdownsApiUrlBase:`${apiUrlBase}/api/dataentry`,
    getAccountInfoGridApiUrlBase:`${apiUrlBase}/api/dataentry/AccountInfo`,

    updateDASubmissionsApiUrlBase:`${apiUrlBase}/api/dataentry-dasubmissionupdate`,

    filetransferApiUrlBase:`${apiUrlBase}/api/postnoaccounts`,
    dataentryApiUrlBase:`${apiUrlBase}/api/dataentry`,
    dataentryAddApiUrlBase:`${apiUrlBase}/api/dataentry-add`,
    dataentryUpdateApiUrlBase:`${apiUrlBase}/api/dataentry-update`,
    dataentryDeleteApiUrlBase:`${apiUrlBase}/api/dataentry-delete`,
    dataentrySubmitApiUrlBase:`${apiUrlBase}/api/dataentry-submit`,
    viewSubmissionApiUrlBase:`${apiUrlBase}/api/viewsubmissions`,


    ExcessApiUrlBase:`${apiUrlBase}/api/excessCurrency`,
    ExcessApiUrlBase1:`${apiUrlBase}/api/excessCurrency1`,
    DepositApiUrlBase:`${apiUrlBase}/api/DepositCurrency`,
    DepositApiUrlBase1:`${apiUrlBase}/api/DepositCurrency/getBundles`,
    DepositApiUrlBaseUpdate:`${apiUrlBase}/api/DepositCurrency/updateValues`,
    DepositApiUrlBaseSave:`${apiUrlBase}/api/DepositCurrency/saveData`,
    FAQApiUrlBase:`${apiUrlBase}/api/FAQ`,

    changePasswordApiUrlBase:`${apiUrlBase}/api/ChangePassword`,
    sendemailApiUrlBase: `${apiUrlBase}/api/ForgotPassword`,

    viewDepositApiUrlBase:`${apiUrlBase}/api/ViewDeposit`,
    viewWithDrawalsDeposit:`${apiUrlBase}/api/viewWithDrawa`,
    withDrawaApiUrlBase:`${apiUrlBase}/api/withDrawa`,
    calculationsApiUrlBase:`${apiUrlBase}/api/calculation`,
    notesUpdateApiUrlBase:`${apiUrlBase}/api/update`,
    saveApiUrlBase:`${apiUrlBase}/api/save`,

    downloadFile:`${apiUrlBase}/api/downloadFile`,
    filetransfersaveApiUrlBase:`${apiUrlBase}/api/filetransfer`,
    getDocumentsDataApiURLBase:`${apiUrlBase}/api/documents`,

    viewSubmissionDeleteApiUrlBase:`${apiUrlBase}/api/viewsubmission-delete`,

    loginSessionActivityApiUrlBase:`${apiUrlBase}/api/loginSession`,
    


};
export default CONFIG;